interface Props {
  value: number;
}

export function CountdownOverlay({ value }: Props) {
  if (value <= 0) return null;
  return (
    <div
      aria-live="polite"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 10,
      }}
    >
      <div
        key={value}
        style={{
          fontSize: 'clamp(120px, 26vw, 220px)',
          fontWeight: 800,
          color: '#fff',
          textShadow: '0 4px 32px rgba(0,0,0,0.6)',
          animation: 'pop 1s ease',
        }}
      >
        {value}
      </div>
      <style>{`
        @keyframes pop {
          0% { transform: scale(0.4); opacity: 0; }
          25% { transform: scale(1.05); opacity: 1; }
          100% { transform: scale(0.85); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
